module.exports = __webpack_public_path__ + "img/slovakia.0c483c31.svg";